<template>
  <div>
    <div class="qyxxbbHeader">
      <el-form
        ref="search"
        label-width="100px"
        :model="formInline"
        style="width: 95%; height: 96px; margin: 0 auto; display: flex"
      >
        <el-form-item label="变更状态：" class="item">
          <el-select v-model="formInline.zt" placeholder="请选择" clearable>
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="变更日期：" class="item">
          <el-col :span="11">
            <el-date-picker
              v-model="formInline.beginBgsqsj"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="开始日期"
              :picker-options="startTime"
              style="width: 100%"
            />
          </el-col>
          <el-col class="line" :span="2" style="text-align: center">-</el-col>
          <el-col :span="11">
            <el-date-picker
              v-model="formInline.endBgsqsj"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="结束日期"
              style="width: 100%"
              :picker-options="endTime"
            />
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button
            v-preventReClick
            style="width: 90px; height: 39px; background: #4170ff"
            round
            icon="el-icon-search"
            type="primary"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="qyxxbbBody">
      <el-table
        v-loading="loadingF"
        :data="tableData"
        :header-cell-style="{
          background: '#F2F2F2',
          color: '#606266',
          height: '10px',
          padding: '0px',
        }"
        style="width: 90%; margin: 0px auto 0 auto"
      >
        <el-table-column prop="date" :render-header="renderHeader">
          <el-table-column align="center" type="selection" />
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="bgmkLabel"
            label="单位信息变更"
          />
          <el-table-column align="center" prop="bgsqrXm" label="变更申请人" />
          <el-table-column
            align="center"
            prop="bgsqsj"
            label="变更申请日期"
            width="200%"
          />
          <el-table-column align="center" prop="status" label="状态">
            <template slot-scope="scope">
              <span
                size="medium"
                :style="{
                  color:
                    scope.row.zt === '00'
                      ? '#ff9900'
                      : scope.row.zt === '11'
                        ? 'blue'
                        : (scope.row.zt === '12' || scope.row.zt === '14')
                          ? 'green'
                          : 'red',
                }"
              >{{ scope.row.zt === '00'
                ? '草稿'
                : scope.row.zt === '11'
                  ? '审批中'
                  : scope.row.zt === '12'
                    ? '已通过'
                    : scope.row.zt === '14'
                      ? '已通过,同步中'
                      : "已拒绝", }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="200%" label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.zt === '00'"
                v-preventReClick
                type="primary"
                style="background: green; border-color: green"
                size="mini"
                icon="el-icon-document"
                @click="handleEdit(scope.$index, scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-if="scope.row.zt === '00'"
                v-preventReClick
                type="primary"
                style="background: red; border-color: red"
                size="mini"
                icon="el-icon-document"
                @click="handleDelete(scope.$index, scope.row)"
              >
                删除
              </el-button>
              <el-button
                v-if="scope.row.zt !== '00'"
                v-preventReClick
                type="primary"
                style="background: #4170ff"
                size="mini"
                icon="el-icon-document"
                @click="handleLook(scope.$index, scope.row)"
              >
                查看
              </el-button>
            </template></el-table-column>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev,pager,next,jumper,total,sizes"
        :total="total"
        :page-sizes="[10, 20]"
        :page-size="pagesize"
        :current-page.sync="currentPage"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>
<script>
import { deleteFraftById, getQyxxBgjl } from '@/assets/js/qyxxbg.js'
export default {
  props: {},
  data() {
    return {
      startTime: {
        disabledDate: (time) => {
          if (this.formInline.endBgsqsj) {
            return (
              time.getTime() > new Date(this.formInline.endBgsqsj).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.formInline.beginBgsqsj) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.formInline.beginBgsqsj).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      // 变更状态KV
      statusList: [
        { label: '草稿', value: '00' },
        { label: '审批中', value: '11' },
        { label: '已通过', value: '12' },
        { label: '已拒绝', value: '13' }
      ],
      // 筛选条件表单
      formInline: {
        zt: '',
        beginBgsqsj: '',
        endBgsqsj: ''
      },
      loadingF: true, // loading遮罩层开关
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      type: false, // 添加和编辑，可编辑，查看不可编辑
      tableData: [], // 列表数据
      total: 0 // 列表总数
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.search()
  },
  beforeDestroy() {},
  methods: {
    // 加载列表数据方法
    search() {
      getQyxxBgjl({
        page: this.currentPage,
        size: this.pagesize,
        param: this.formInline
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
        this.loadingF = false // 关闭遮罩层
      })
    },
    // 查看当前记录
    handleLook(index, row) {
      this.$emit('getTreeData', {
        dialogForm: false,
        lookFlag: true,
        lookId: row.id
      })
    },
    // 编辑草稿index行指针 row此行内容
    handleEdit(index, row) {
      this.$emit('getTreeData', {
        dialogForm: false,
        lookFlag: false,
        id: row.id
      })
    },
    // 删除行数据草稿
    handleDelete(index, row) {
      // 获取数据id
      var deleteId = this.tableData[index].id
      deleteFraftById(deleteId)
        .then((e) => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.tableData.splice(index, 1)
        })
        .catch((error) => {
          this.$message.error(error.response.data.mesg)
        })
    },
    // 表头的按钮
    renderHeader() {
      return (
        <div>
          <el-button
            type='primary'
            style='background: #4170ff; margin: 10px 0 10px 10px'
            size='mini'
            icon='el-icon-plus'
            onClick={() => this.addMes()}
          >
            新增
          </el-button>
        </div>
      )
    },
    // 新增方法
    addMes() {
      try {
        this.tableData.forEach((element) => {
          if (element.zt === '00' || element.zt === '11' || element.zt === '14') {
            this.$message({
              message: '当前列表中存在草稿或审批中的申请或正在同步中的申请！',
              type: 'warning'
            })
            throw new Error('ending') // 存在草稿或审批中的申请或正在同步中的申请  不可继续执行
          }
        })
        this.$emit('getTreeData', { dialogForm: false, id: '' })
      } catch (e) {
        if (e.message == 'ending') {
        } else {
          log(e.message)
        }
      }
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.search()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.search()
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-form-item__label {
  color: #333333;
}
.qyxxbbHeader {
  width: 95%;
  max-width: 1518px;
  margin: 30px auto 11px auto;
  height: 96px;
  line-height: 96px;
  background-color: #fff;
  display: flex;
  .el-form {
    line-height: 96px;
    align-items: center;
    .el-form-item:nth-child(1) {
      margin-right: 30px;
    }
    .el-form-item:nth-child(2) {
      margin-right: 30px;
    }
    .el-form-item {
      margin: 0;
      .el-form--inline .el-form-item__content {
        display: inline-block;
        vertical-align: auto;
      }
    }
  }
}
.qyxxbbBody {
  padding: 40px 0px 57px 0px;
  max-width: 1518px;
  width: 95%;
  background-color: #fff;
  margin: auto;
  .el-pagination {
    width: 90%;
    padding: 10px 0;
    border: 1px solid #ebeef5;
    margin: 0 auto 0px auto;
    border-top: 0;
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
